import React from 'react';
import { connect } from 'react-redux';
import {
    getAgentId,
    getFullPromocode,
    getIsLoadingPromocodeCheck,
    getPromocodeMessage,
    getPromocodeStatus
} from "../../selectors";
import {showLoader} from "../../utils";
import {
    MESSAGE_NO_AGENT,
    MESSAGE_NO_MIGRATION_PARAM, MESSAGE_WRONG_PROMO_CODE,
    PAGE_PROMO_CODE_FAILED,
} from "../../constants";
import {
    setInvalidPromocode,
    setPromocodeData,
    validateAgentPromotionAction,
} from "../../reducers";
import {useNavigate} from "react-router-dom";

const useComponentDidMount = onMountHandler => {
    React.useEffect(() => {
        onMountHandler();
    }, []);
};

const stateToProps = state => ({
    promocodeStatus: getPromocodeStatus(state),
    fullPromocode: getFullPromocode(state),
    promocodeMessage: getPromocodeMessage(state),
    isLoadingPromocodeCheck: getIsLoadingPromocodeCheck(state),
    agentId: getAgentId(state),
});

const actionsToProps = dispatch => ({
    validateAgentPromotion: payload => dispatch(validateAgentPromotionAction(payload)),
    setInvalidPromocode: payload => dispatch(setInvalidPromocode(payload)),
    setPromocodeData: payload => dispatch(setPromocodeData(payload)),
});

const Promocode = props => {

    const navigate = useNavigate();
    const urlSearchParams = new URLSearchParams(document.location.search);

    useComponentDidMount(() => {
        const promoParam = urlSearchParams.get('promocode');
        const promo = promoParam ? promoParam.replace(/\s+/g, '') : null;
        const validCode = isPromoValid(promo);
        const migrationParam = urlSearchParams.get('migration_param');

        if (validCode) {
            if (promo.includes('MIGRATION')) {
                if (!migrationParam) {
                    props.setInvalidPromocode(MESSAGE_NO_MIGRATION_PARAM);
                    navigate(PAGE_PROMO_CODE_FAILED);
                } else {
                    props.validateAgentPromotion({promotion: validCode, fullCode: promo, migrationParam});
                }
            } else if (migrationParam) {
                props.setInvalidPromocode(MESSAGE_WRONG_PROMO_CODE);
                navigate(PAGE_PROMO_CODE_FAILED);
            } else {
                props.validateAgentPromotion({promotion: validCode, fullCode: promo});
            }
        }
    });

    const isPromoValid = (promo) => {
        if (!promo) {
            props.setPromocodeData({
                promocodeStatus: 'error',
                promocodeMessage: 'Please use a valid link with a promocode to register under your agent.',
                code: '',
            });

            props.setInvalidPromocode(MESSAGE_NO_AGENT);
            navigate(PAGE_PROMO_CODE_FAILED);
        } else {
            const promocode = (promo.split('-')[0]) * 1;
            if (!Number.isInteger(promocode)) {
                props.setPromocodeData({
                    promocodeStatus: 'error',
                    promocodeMessage: 'Agent promotion code is not valid.',
                    code: ''
                });

                return false;
            }
            return promocode;
        }
    };

    return (
        <div className={`form-row ${props.promocodeStatus}`}>
            <label className="form-label">
                {props.isLoadingPromocodeCheck && showLoader()}
                Promocode <span className="asterisk">*</span>
            </label>

            <input type="text" id="promocode" className="form-input" value={props.fullPromocode} disabled/>

            <p className="callout error p10 txt-l">
                {props.promocodeMessage}
            </p>

            <i className="form-status"/>

            <p className="callout p10 txt-l">
                The Promocode provided by your Agent.
            </p>
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(Promocode);
